(() => {
  function mount(lifecycle) {
    const staticMotion = window.matchMedia('(prefers-reduced-motion: reduce), (hover: none)');
    document.querySelectorAll('[data-marquee]').forEach(bar => {
      const button = bar.querySelector('[data-marquee-toggle]');
      if (!button) return;
      let paused = bar.dataset.marqueePaused === 'true';
      function update() {
        bar.dataset.marqueePaused = String(paused);
        button.textContent = paused ? button.dataset.playLabel : button.dataset.pauseLabel;
        button.setAttribute('aria-label', paused ? button.dataset.playDescription : button.dataset.pauseDescription);
        if (staticMotion.matches && document.activeElement === button) bar.focus({preventScroll: true});
        button.hidden = staticMotion.matches;
      }
      button.addEventListener('click', () => {
        paused = !paused;
        update();
      }, lifecycle.options());
      staticMotion.addEventListener('change', update, lifecycle.options());
      update();
      bar.dataset.marqueeReady = 'true';
    });
  }
  window.GOBBI_MARQUEE = {mount};
})();

(() => {
  function mount(lifecycle,changedSection) {
    // Section previews may update without rerendering the global catalog script.
    for(const scope of [document,changedSection].filter(Boolean)){
      scope.querySelectorAll('[data-gobbi-card-image]').forEach(image=>{
        const product=window.GOBBI_CATALOG?.find(p=>p.id===image.dataset.gobbiCardImage);
        if(product)product.image=image.getAttribute('src');
      });
      const thermos=scope.querySelector('[data-gobbi-thermos-image]');
      if(thermos&&window.GOBBI_ASSETS)window.GOBBI_ASSETS.thermos=thermos.getAttribute('src');
    }
    const gallery=document.querySelector('[data-gobbi-managed-gallery]');
    if(!gallery)return;
    const rail=gallery.querySelector('.thumbs'),main=gallery.querySelector('#main-product-image');
    if(!rail||!main)return;
    const prior=gallery.dataset.selectedImage;
    rail.replaceChildren();
    document.querySelectorAll('template[data-gobbi-gallery-source]').forEach(source=>{
      if(source.dataset.product===document.body.dataset.product)rail.append(source.content.cloneNode(true));
    });
    const buttons=[...rail.querySelectorAll('[data-gallery-key]')];
    gallery.hidden=buttons.length===0;
    gallery.closest('.product-layout')?.classList.toggle('gobbi-no-gallery',buttons.length===0);
    rail.hidden=buttons.length<2;
    if(!buttons.length){
      ['src','srcset','sizes'].forEach(a=>main.removeAttribute(a));
      delete gallery.dataset.selectedImage;
      return;
    }
    function select(button,focus=false) {
      const image=button.querySelector('img');
      main.removeAttribute('srcset');
      main.setAttribute('src',image.dataset.full||image.src);
      if(image.dataset.srcset){
        main.srcset=image.dataset.srcset;
        main.sizes='(max-width: 1050px) calc(100vw - 48px), 48vw';
      }else main.removeAttribute('sizes');
      main.alt=image.alt;
      main.width=Number(image.dataset.width)||1254;
      main.height=Number(image.dataset.height)||1254;
      main.style.objectFit=button.dataset.fit||'contain';
      main.style.objectPosition=image.dataset.position||'50% 50%';
      main.style.mixBlendMode='normal';
      gallery.dataset.selectedImage=button.dataset.galleryKey;
      buttons.forEach(b=>{b.classList.toggle('selected',b===button);b.setAttribute('aria-pressed',String(b===button));});
      if(focus){button.focus({preventScroll:true});button.scrollIntoView?.({block:'nearest',inline:'nearest'});}
    }
    for(const button of buttons){
      button.addEventListener('click',()=>select(button),lifecycle.options());
      button.addEventListener('keydown',event=>{
        const index=buttons.indexOf(button);let target;
        if(['ArrowRight','ArrowDown'].includes(event.key))target=buttons[(index+1)%buttons.length];
        if(['ArrowLeft','ArrowUp'].includes(event.key))target=buttons[(index-1+buttons.length)%buttons.length];
        if(event.key==='Home')target=buttons[0];if(event.key==='End')target=buttons.at(-1);
        if(target){event.preventDefault();select(target,true);}
      },lifecycle.options());
    }
    select(buttons.find(b=>b.dataset.galleryKey===prior)||buttons[0]);
    document.addEventListener('shopify:block:select',event=>{
      const button=buttons.find(b=>b.dataset.galleryBlock===event.detail?.blockId&&(!event.detail?.sectionId||b.dataset.gallerySection===event.detail.sectionId));
      if(button){select(button);gallery.scrollIntoView?.({block:'center'});}
    },lifecycle.options());
    document.addEventListener('shopify:section:select',event=>{
      const button=buttons.find(b=>b.dataset.gallerySection===event.detail?.sectionId);
      if(button){select(button);gallery.scrollIntoView?.({block:'center'});}
    },lifecycle.options());
  }
  window.GOBBI_IMAGES={mount};
})();

(() => {
  const defaults={link:'Watch on Instagram ↗',fallback:'A moment with GOBBi.',videoError:'Watch this GOBBi video on Instagram.',ready:'Latest videos from @sipgobbi · Updates automatically',cached:'Showing the last loaded videos. View @sipgobbi for the latest.',error:'The video feed is unavailable right now. Watch directly on Instagram.',videoLabel:'GOBBi Instagram video {value_1}',showStatus:true};
  const feedUrl='https://api.nfcube.com/feed/v6?limit=12&account=qpinkq-2m.myshopify.com&fu=0&fid=0&hash=6509e7ad6bbd48b07ce622b3de7ee9ae&locale=en&handle=';
  let cachedVideos=null,lastFetch=0;
  function safeUrl(value,kind){
    try{const url=new URL(value);if(url.protocol!=='https:')return null;const host=url.hostname.toLowerCase();
      if(kind==='link')return ['www.instagram.com','instagram.com'].includes(host)?url.href:null;
      return ['cdninstagram.com','fbcdn.net','nfcube.com'].some(domain=>host===domain||host.endsWith('.'+domain))?url.href:null;
    }catch{return null;}
  }
  function postKey(value){const safe=safeUrl(value,'link');if(!safe)return null;return new URL(safe).pathname.match(/^\/(?:reel|reels|p)\/([^/]+)/)?.[1]||null;}
  function read(node){try{return JSON.parse(node?.textContent||'{}');}catch{return {};}}
  function write(node,value){node.replaceChildren(document.createTextNode(String(value??'')));}
  function mount(lifecycle){
    const container=document.getElementById('instagram-videos');if(!container)return;
    const section=container.closest('.instagram-section'),status=section.querySelector('#instagram-status'),fallback=section.querySelector('#instagram-fallback');
    const config={...defaults,...read(section.querySelector('[data-gobbi-instagram-settings]'))};
    for(const key of Object.keys(defaults))if(config[key]==null)config[key]=defaults[key];
    const overrides=Array.from(section.querySelectorAll('[data-gobbi-video-caption]'),template=>{const node=template.content.querySelector('script');return {node,...read(node)};});
    function setStatus(key){if(status){status.hidden=config.showStatus===false;write(status,config[key]);}}
    function render(videos){
      const fragment=document.createDocumentFragment();let count=0;
      for(const item of videos){
        const permalink=safeUrl(item.link,'link'),videoUrl=safeUrl(item.videos?.standard_resolution?.url,'media'),poster=safeUrl(item.images?.standard_resolution?.url,'media');
        if(!permalink||!videoUrl)continue;
        const number=count+1,key=postKey(permalink);
        const override=overrides.find(block=>block.postUrl&&postKey(block.postUrl)===key)||overrides.find(block=>!block.postUrl&&Number(block.position)===number);
        const card=document.createElement('article');card.className='reel-card';
        if(override)for(const attribute of override.node.attributes)if(attribute.name.startsWith('data-shopify-editor'))card.setAttribute(attribute.name,attribute.value);
        const video=document.createElement('video');video.controls=true;video.playsInline=true;video.preload='none';video.src=videoUrl;if(poster)video.poster=poster;video.setAttribute('aria-label',config.videoLabel.replace('{value_1}',String(number)));
        video.addEventListener('play',()=>container.querySelectorAll('video').forEach(other=>{if(other!==video)other.pause();}),lifecycle.options());
        const caption=document.createElement('p');caption.className='reel-caption';
        const original=typeof item.caption?.text==='string'&&item.caption.text?item.caption.text:config.fallback;
        const text=override?.caption?.trim()?override.caption:original.length>150?original.slice(0,147)+'…':original;
        write(caption,text);caption.hidden=override?.showCaption===false||!text;
        const link=document.createElement('a');link.href=permalink;link.target='_blank';link.rel='noopener';write(link,override?.linkText||config.link);
        video.addEventListener('error',()=>{
          video.hidden=true;card.classList.add('reel-unavailable');
          if(!card.querySelector('.reel-error')){const error=document.createElement('p');error.className='reel-error';write(error,config.videoError);card.insertBefore(error,link);}
        },lifecycle.options());
        card.append(video,caption,link);fragment.append(card);count++;
        if(count===4)break;
      }
      if(!count)return false;
      container.replaceChildren(fragment);if(fallback)fallback.hidden=true;setStatus('ready');return true;
    }
    async function refresh(force=false){
      if(!lifecycle.active)return;
      if(!force&&cachedVideos&&Date.now()-lastFetch<600000)return;
      const controller=lifecycle.resource('AbortController');const timeout=lifecycle.timeout(()=>controller.abort(),12000);
      try{
        const response=await lifecycle.fetch(feedUrl,{credentials:'omit',signal:controller.signal});
        if(!response.ok)throw new Error('Feed unavailable');
        const payload=await response.json();if(!lifecycle.active||!container.isConnected)return;
        const videos=(Array.isArray(payload.data)?payload.data:[]).filter(item=>item.type==='video'&&item.user?.username==='sipgobbi');
        if(!render(videos))throw new Error('No videos');
        cachedVideos=videos;lastFetch=Date.now();
      }catch{
        if(!lifecycle.active||!container.isConnected)return;
        setStatus(container.childElementCount?'cached':'error');
      }finally{clearTimeout(timeout);}
    }
    if(cachedVideos)render(cachedVideos);
    refresh();
    lifecycle.interval(()=>{if(document.visibilityState==='visible')refresh();},600000);
    document.addEventListener('visibilitychange',()=>{if(document.visibilityState==='visible')refresh();},lifecycle.options());
    document.addEventListener('shopify:block:select',event=>{
      const id=event.detail?.blockId;if(!id)return;
      for(const card of container.querySelectorAll('[data-shopify-editor-block]'))try{if(JSON.parse(card.dataset.shopifyEditorBlock).id===id)card.scrollIntoView({block:'nearest',inline:'nearest'});}catch{}
    },lifecycle.options());
  }
  window.GOBBI_INSTAGRAM={mount};
})();

(() => {
  if(window.GOBBI_EDITOR)return;
  const caches=new WeakMap();
  function read(node){
    if(!node)return {};
    if(caches.get(node)?.source!==node.textContent)try{caches.set(node,{source:node.textContent,value:JSON.parse(node.textContent)});}catch{caches.set(node,{source:node.textContent,value:{}});}
    return caches.get(node).value;
  }
  function dictionary(element){
    const values={...read(document.getElementById('gobbi-global-copy'))};
    const scope=element?.closest?.('.shopify-section')||element;
    scope?.querySelectorAll?.('[data-gobbi-section-copy]').forEach(node=>{
      for(const [key,value] of Object.entries(read(node)))if(key!==value||!Object.hasOwn(values,key))values[key]=value;
    });
    return values;
  }
  // Resolve complete copy keys only. Never search inside product names, prices,
  // customer text, or an already edited phrase for words to replace.
  function text(value,element){
    const input=String(value??''),trimmed=input.trim(),values=dictionary(element);
    return Object.hasOwn(values,trimmed)?input.replace(trimmed,()=>String(values[trimmed]??'')):input;
  }
  function format(source,values=[],element){
    const keys=[...new Set(String(source).match(/\{value_\d+\}/g)||[])];
    const replacements=Object.fromEntries(keys.map((key,index)=>[key,String(values[index]??'')]));
    return text(source,element).replace(/\{value_\d+\}/g,key=>Object.hasOwn(replacements,key)?replacements[key]:key);
  }
  function html(value,element){
    const template=document.createElement('template');template.innerHTML=String(value??'');
    const final=node=>node?.closest?.('[data-gobbi-copy-final]');
    const walker=document.createTreeWalker(template.content,NodeFilter.SHOW_TEXT);
    while(walker.nextNode())if(!final(walker.currentNode.parentElement))walker.currentNode.textContent=text(walker.currentNode.textContent,element);
    template.content.querySelectorAll('[aria-label],[aria-valuetext],[title],[placeholder],[alt],optgroup[label]').forEach(node=>{
      if(final(node))return;
      for(const name of ['aria-label','aria-valuetext','title','placeholder','alt','label'])if(node.hasAttribute(name))node.setAttribute(name,text(node.getAttribute(name),element));
    });
    return template.innerHTML;
  }
  let current,timer,changedSection;
  function start(){
    current?.destroy();
    const controller=new AbortController(),timeouts=new Set(),intervals=new Set(),resources=[];
    const lifecycle={active:true,
      options(options={}){return {...(typeof options==='boolean'?{capture:options}:options),signal:controller.signal};},
      timeout(fn,ms,...args){const id=setTimeout(()=>{timeouts.delete(id);if(lifecycle.active)fn(...args);},ms);timeouts.add(id);return id;},
      interval(fn,ms,...args){const id=setInterval(()=>{if(lifecycle.active)fn(...args);},ms);intervals.add(id);return id;},
      resource(type,...args){const resource=new window[type](...args);resources.push(resource);return resource;},
      fetch(url,options={}){const signal=options.signal?AbortSignal.any([controller.signal,options.signal]):controller.signal;return window.fetch(url,{...options,signal});},
      destroy(){lifecycle.active=false;controller.abort();timeouts.forEach(clearTimeout);intervals.forEach(clearInterval);resources.forEach(r=>{r.disconnect?.();r.abort?.();});}
    };
    current=lifecycle;
    document.querySelectorAll('#welcome-form-status,#notify-form-status').forEach(node=>node.remove());
    document.querySelectorAll('dialog[open]').forEach(dialog=>dialog.close());
    document.body.classList.remove('bag-is-open');
    window.GOBBI_IMAGES?.mount(lifecycle,changedSection);
    window.GOBBI_INSTAGRAM?.mount(lifecycle);
    window.GOBBI_MARQUEE?.mount(lifecycle);
    changedSection=null;
    if(document.getElementById('notify-form')&&document.getElementById('open-bag'))window.GOBBI_MOUNT(lifecycle);
  }
  function schedule(event){changedSection=event?.target?.isConnected?event.target:null;clearTimeout(timer);current?.destroy();timer=setTimeout(start,30);}
  document.addEventListener('shopify:section:load',schedule);
  document.addEventListener('shopify:section:unload',schedule);
  document.addEventListener('shopify:section:reorder',schedule);
  window.GOBBI_EDITOR={text,format,html,start};
})();

window.GOBBI_MOUNT=function(GOBBI_LIFECYCLE){
(() => {
  const catalog = window.GOBBI_CATALOG;
  const copy = (source, values = [], element) => GOBBI_EDITOR.format(source, values, element);
  const copyHTML = (source, values = [], element) => nativeEscape(copy(source, values, element));
  const money = cents => new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: globalThis.GOBBI_SHOPIFY?.currency || 'USD'
  }).format(cents / 100);
  const byId = id => catalog.find(product => product.id === id);
  function normalizeSelection(selection) {
    const result = {};
    if (!selection || typeof selection !== 'object') return result;
    for (const [id, quantity] of Object.entries(selection)) {
      const product = byId(id);
      if (product?.available && Number.isInteger(quantity) && quantity > 0) result[id] = Math.min(quantity, product.stock);
    }
    return result;
  }
  function quote(selection, mode = 'subscription', months = 1, welcome = false) {
    if (!['subscription', 'once'].includes(mode) || ![1, 2, 3].includes(Number(months))) throw new Error(GOBBI_EDITOR.text('Invalid purchase choice'));
    const lines = [];
    for (const [id, quantity] of Object.entries(selection)) {
      const product = byId(id);
      if (!product || !Number.isInteger(quantity) || quantity < 0) throw new Error(GOBBI_EDITOR.text('Invalid box selection'));
      if (!quantity) continue;
      const base = product.price * quantity;
      const native = globalThis.GOBBI_SHOPIFY?.enabled === true;
      const plan = native ? product.plans?.find(plan => plan.months === Number(months) && plan.recurring && Number.isSafeInteger(plan.id) && plan.price === Math.round(product.price * .8) && plan.perDeliveryPrice === plan.price && Array.isArray(plan.cyclePrices) && plan.cyclePrices.length > 0 && plan.cyclePrices.every(price => Number.isSafeInteger(price) && price === plan.price)) : null;
      const planAvailable = !native || (mode === 'once' ? !product.requiresSellingPlan : globalThis.GOBBI_SHOPIFY.subscriptionsEnabled === true && globalThis.GOBBI_SHOPIFY.giftBackendVerified === true && !!plan);
      const total = native ? mode === 'subscription' && plan ? plan.price * quantity : base : mode === 'subscription' || welcome ? Math.round(base * .8) : base;
      lines.push({
        product,
        quantity,
        base,
        total,
        available: product.available && quantity <= product.stock,
        planAvailable,
        sellingPlanId: mode === 'subscription' ? plan?.id : undefined
      });
    }
    const base = lines.reduce((sum, line) => sum + line.base, 0);
    const total = lines.reduce((sum, line) => sum + line.total, 0);
    const boxes = lines.reduce((sum, line) => sum + line.quantity, 0);
    const stockAvailable = lines.length > 0 && lines.every(line => line.available);
    const plansAvailable = lines.every(line => line.planAvailable);
    return {
      lines,
      base,
      total,
      boxes,
      sticks: boxes * 10,
      savings: base - total,
      months: Number(months),
      mode,
      stockAvailable,
      plansAvailable,
      canPurchase: stockAvailable && plansAvailable,
      renewal: mode === 'subscription' ? total : null,
      gift: globalThis.GOBBI_SHOPIFY?.enabled !== true && mode === 'subscription' && boxes > 0
    };
  }
  function cartQuote(cart, welcome = false, newSubscriber = true) {
    const lines = cart.map(item => ({
      ...item,
      ...quote({
        [item.id]: item.quantity
      }, item.mode, item.months, welcome)
    }));
    const countByProduct = {};
    for (const item of cart) countByProduct[item.id] = (countByProduct[item.id] || 0) + item.quantity;
    const withinStock = Object.entries(countByProduct).every(([id, qty]) => byId(id)?.available && qty <= byId(id).stock);
    return {
      lines,
      total: lines.reduce((sum, line) => sum + line.total, 0),
      boxes: lines.reduce((sum, line) => sum + line.boxes, 0),
      gift: newSubscriber && lines.some(line => line.gift),
      canPurchase: lines.length > 0 && lines.every(line => line.canPurchase) && withinStock
    };
  }
  const intervalText = months => Number(months) === 1 ? copy('every month') : copy('every {value_1} months', [months]);
  function resizeSlots(slots, size, defaultId) {
    if (![1, 2, 3].includes(size) || !byId(defaultId)) throw new Error(GOBBI_EDITOR.text('Invalid box count or flavor'));
    const result = Array.isArray(slots) ? slots.filter(id => byId(id)).slice(0, size) : [];
    while (result.length < size) result.push(defaultId);
    return result;
  }
  function slotsToSelection(slots) {
    const result = {};
    for (const id of slots) {
      if (!byId(id)) throw new Error(GOBBI_EDITOR.text('Unknown flavor'));
      result[id] = (result[id] || 0) + 1;
    }
    return result;
  }
  function groupCart(cart, welcome = false) {
    const groups = [];
    cart.forEach((item, index) => {
      let group = groups.find(g => g.mode === item.mode && g.months === item.months);
      if (!group) {
        group = {
          mode: item.mode,
          months: item.months,
          items: [],
          selection: {}
        };
        groups.push(group);
      }
      group.items.push({
        ...item,
        index
      });
      group.selection[item.id] = (group.selection[item.id] || 0) + item.quantity;
    });
    return groups.map(group => ({
      ...group,
      ...quote(group.selection, group.mode, group.months, welcome)
    }));
  }
  const positiveId = value => Number.isSafeInteger(value) && value > 0;
  const GIFT_POLL_MS = 250, GIFT_STABLE_MS = 1000, GIFT_TIMEOUT_MS = 8000;
  function verifiedGiftConfig(value) {
    if (value?.enabled !== true || value?.backendVerified !== true) return null;
    const validIds = ids => Array.isArray(ids) && ids.length > 0 && ids.every(positiveId);
    if (value.strategy !== 'appstle' || !positiveId(value.variantId) || !validIds(value.qualifyingVariantIds) || !validIds(value.qualifyingPlanIds) || value.qualifyingVariantIds.includes(value.variantId)) throw new Error(GOBBI_EDITOR.text('The subscription gift configuration is incomplete.'));
    return {
      variantId: value.variantId,
      variants: new Set(value.qualifyingVariantIds),
      plans: new Set(value.qualifyingPlanIds)
    };
  }
  function createShopifyCart({root = '/', request = (...args) => GOBBI_LIFECYCLE.fetch(...args), onChange = () => {}, canCheckout = () => true, subscriptionGift, delay = ms => new Promise(resolve => GOBBI_LIFECYCLE.timeout(resolve, ms)), now = () => globalThis.performance?.now() ?? Date.now()} = {}) {
    if (typeof root !== 'string' || !root.startsWith('/') || root.startsWith('//')) throw new Error(GOBBI_EDITOR.text('Invalid Shopify cart route.'));
    const base = root.endsWith('/') ? root : root + '/';
    const gift = verifiedGiftConfig(subscriptionGift);
    let cart = null, busy = false, stale = true, error = '', generation = 0, checkoutLocked = false;
    const snapshot = () => ({
      cart,
      busy,
      stale,
      error,
      checkoutLocked
    });
    const publish = () => onChange(snapshot());
    const isGiftLine = item => Boolean(gift && item?.variant_id === gift.variantId && ['_appstle_parent_product', '_appstle_parent_selling_plan', '_appstle_free_product', '_gobbi_subscription_gift'].some(key => Object.prototype.hasOwnProperty.call(item.properties || ({}), key)));
    const qualifies = item => Boolean(gift && item?.quantity > 0 && gift.variants.has(item.variant_id) && gift.plans.has(item.selling_plan_allocation?.selling_plan?.id));
    const matchesParent = (item, parent) => String(item.properties?._appstle_parent_product) === String(parent.variant_id) && String(item.properties?._appstle_parent_selling_plan) === String(parent.selling_plan_allocation.selling_plan.id);
    const isManagedGift = item => Boolean(isGiftLine(item) && cart?.items.some(parent => qualifies(parent) && matchesParent(item, parent)));
    const giftRelevant = () => Boolean(gift && cart?.items.some(item => qualifies(item) || isGiftLine(item)));
    async function read({timeoutMs = 0} = {}) {
      const version = ++generation;
      let timer, controller;
      try {
        if (timeoutMs > 0) controller = GOBBI_LIFECYCLE.resource("AbortController");
        const pending = (async () => {
          const response = await request(base + 'cart.js', {
            credentials: 'same-origin',
            cache: 'no-store',
            headers: {
              Accept: 'application/json'
            },
            ...controller ? {
              signal: controller.signal
            } : {}
          });
          if (!response.ok) throw new Error(GOBBI_EDITOR.text('Your bag could not be refreshed. Please try again.'));
          return response.json();
        })();
        const value = await (timeoutMs > 0 ? Promise.race([pending, new Promise((resolve, reject) => {
          timer = GOBBI_LIFECYCLE.timeout(() => {
            reject(new Error(GOBBI_EDITOR.text('Your bag could not be refreshed in time. Checkout is paused. Please try again.')));
            controller.abort();
          }, timeoutMs);
        })]) : pending);
        if (!Array.isArray(value.items) || !Number.isFinite(value.total_price) || typeof value.currency !== 'string') throw new Error(GOBBI_EDITOR.text('Shopify returned an unreadable bag. Please refresh it.'));
        if (version === generation) {
          cart = value;
          stale = false;
          if (!busy) error = '';
          publish();
        }
        return value;
      } catch (cause) {
        if (version === generation) {
          stale = true;
          publish();
        }
        throw cause;
      } finally {
        clearTimeout(timer);
      }
    }
    async function writeAndRead(path, body) {
      stale = true;
      generation++;
      publish();
      let failure;
      try {
        const response = await request(base + path, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify(body)
        });
        let value;
        try {
          value = await response.json();
        } catch {
          throw new Error(GOBBI_EDITOR.text('Shopify did not confirm the update. Review your bag before trying again.'));
        }
        if (!response.ok) throw new Error(typeof value.description === 'string' ? value.description : typeof value.message === 'string' ? value.message : copy('Shopify could not update your bag.'));
      } catch (cause) {
        failure = cause instanceof Error && !(cause instanceof TypeError) ? cause : new Error(GOBBI_EDITOR.text('The update was not confirmed. Review your bag before trying again.'));
      }
      try {
        await read({
          timeoutMs: gift ? GIFT_TIMEOUT_MS : 0
        });
      } catch (cause) {
        failure = new Error(GOBBI_EDITOR.text('Your bag could not be refreshed. The last update may have reached Shopify. Refresh your bag before adding again.'));
      }
      if (failure) throw failure;
    }
    function giftProblem() {
      const lines = cart.items.filter(isGiftLine), parents = cart.items.filter(qualifies);
      if (!parents.length) return lines.length ? 'Appstle has not removed the thermos from this bag yet. Checkout is paused. Refresh your bag and try again.' : '';
      if (lines.length !== 1 || lines[0].quantity !== 1) return 'Appstle has not confirmed one thermos for this subscription. Checkout is paused. Refresh your bag and try again.';
      if (!parents.some(parent => matchesParent(lines[0], parent))) return 'Appstle has not linked the thermos to a qualifying subscription yet. Checkout is paused. Refresh your bag and try again.';
      if (lines[0].selling_plan_allocation || lines[0].selling_plan) return 'Appstle has not confirmed the thermos as a one-time gift. Checkout is paused. Refresh your bag and try again.';
      if (lines[0].final_line_price !== 0 || lines[0].final_price !== undefined && lines[0].final_price !== 0) return 'The free thermos discount has not been confirmed by Shopify. Checkout is paused. Remove the subscription to continue with a one-time order.';
      return '';
    }
    async function settleGift(force = false) {
      if (!gift || !force && !giftRelevant()) return;
      if (stale || !cart) throw new Error(GOBBI_EDITOR.text('Refresh your bag before checking the subscription thermos.'));
      const start = now();
      let stableSince = null, lastFingerprint = '';
      for (let attempt = 0; attempt <= GIFT_TIMEOUT_MS / GIFT_POLL_MS; attempt++) {
        const problem = giftProblem();
        const fingerprint = JSON.stringify({
          items: cart.items,
          total_price: cart.total_price,
          currency: cart.currency
        });
        if (problem) {
          stableSince = null;
          lastFingerprint = '';
        } else if (fingerprint !== lastFingerprint) {
          stableSince = now();
          lastFingerprint = fingerprint;
        } else if (stableSince !== null && now() - stableSince >= GIFT_STABLE_MS) return;
        const remaining = GIFT_TIMEOUT_MS - (now() - start);
        if (remaining <= 0 || attempt === GIFT_TIMEOUT_MS / GIFT_POLL_MS) throw new Error(GOBBI_EDITOR.text(problem || 'Your bag is still being updated by Appstle. Checkout is paused. Refresh it and try again.'));
        await delay(Math.min(GIFT_POLL_MS, remaining));
        const readBudget = GIFT_TIMEOUT_MS - (now() - start);
        if (readBudget <= 0) throw new Error(GOBBI_EDITOR.text(problem || 'Your bag is still being updated by Appstle. Checkout is paused. Refresh it and try again.'));
        await read({
          timeoutMs: readBudget
        });
        if (stale) throw new Error(GOBBI_EDITOR.text('Refresh your bag before checking the subscription thermos.'));
      }
    }
    function assertEditable(key) {
      if (cart?.items.some(item => item.key === key && isGiftLine(item))) throw new Error(GOBBI_EDITOR.text('Appstle manages this thermos with the subscription. Remove the subscription to remove it; its quantity is fixed at one.'));
    }
    async function mutate(path, body) {
      if (busy) throw new Error(GOBBI_EDITOR.text('Your bag is still updating.'));
      if (path === 'cart/change.js' && !stale) assertEditable(body.id);
      const needsRead = stale;
      busy = true;
      stale = true;
      error = '';
      generation++;
      publish();
      let failure;
      try {
        if (needsRead) await read({
          timeoutMs: gift ? GIFT_TIMEOUT_MS : 0
        });
        if (path === 'cart/change.js') assertEditable(body.id);
        const giftWasRelevant = giftRelevant() || Boolean(gift && body.items?.some(item => gift.variants.has(item.id) && gift.plans.has(item.selling_plan)));
        await writeAndRead(path, body);
        await settleGift(giftWasRelevant);
      } catch (cause) {
        failure = cause instanceof Error ? cause : new Error(GOBBI_EDITOR.text('Your bag could not be updated. Please refresh it.'));
      }
      busy = false;
      error = failure?.message || '';
      publish();
      if (failure) throw failure;
      return cart;
    }
    async function add(lines) {
      if (busy) throw new Error(GOBBI_EDITOR.text('Your bag is still updating.'));
      if (!Array.isArray(lines) || !lines.length) throw new Error(GOBBI_EDITOR.text('Choose a box first.'));
      const items = lines.map(line => {
        if (!Number.isSafeInteger(line.id) || line.id <= 0 || !Number.isInteger(line.quantity) || line.quantity <= 0) throw new Error(GOBBI_EDITOR.text('This box is not linked to a purchasable Shopify variant.'));
        const item = {
          id: line.id,
          quantity: line.quantity
        };
        if (line.selling_plan !== undefined) {
          if (!Number.isSafeInteger(line.selling_plan) || line.selling_plan <= 0) throw new Error(GOBBI_EDITOR.text('A valid subscription plan is required.'));
          item.selling_plan = line.selling_plan;
        }
        return item;
      });
      if (stale && cart) throw new Error(GOBBI_EDITOR.text('Refresh your bag and review its contents before adding again.'));
      return mutate('cart/add.js', {
        items
      });
    }
    async function remove(key) {
      if (typeof key !== 'string' || !key) throw new Error(GOBBI_EDITOR.text('Refresh your bag before removing this item.'));
      return mutate('cart/change.js', {
        id: key,
        quantity: 0
      });
    }
    async function setQuantity(key, quantity) {
      if (busy) throw new Error(GOBBI_EDITOR.text('Your bag is still updating.'));
      if (!Number.isSafeInteger(quantity) || quantity < 0) throw new Error(GOBBI_EDITOR.text('Choose a valid item quantity.'));
      if (stale || !cart || typeof key !== 'string' || !key || !cart.items.some(item => item.key === key)) throw new Error(GOBBI_EDITOR.text('Refresh your bag before changing this quantity.'));
      return mutate('cart/change.js', {
        id: key,
        quantity
      });
    }
    async function prepareCheckout() {
      if (busy) throw new Error(GOBBI_EDITOR.text('Your bag is still updating.'));
      busy = true;
      checkoutLocked = true;
      error = '';
      publish();
      try {
        const giftWasRelevant = giftRelevant();
        await read({
          timeoutMs: gift ? GIFT_TIMEOUT_MS : 0
        });
        if (stale) throw new Error(GOBBI_EDITOR.text('Refresh your bag before checkout.'));
        if (!cart?.items.length) throw new Error(GOBBI_EDITOR.text('Your bag is empty.'));
        if (!canCheckout(cart)) throw new Error(GOBBI_EDITOR.text('Subscriptions in this bag are not ready for checkout from this draft. Remove them to continue with a one-time order.'));
        await settleGift(giftWasRelevant);
        if (stale) throw new Error(GOBBI_EDITOR.text('Refresh your bag before checkout.'));
        if (!cart?.items.length) throw new Error(GOBBI_EDITOR.text('Your bag is empty.'));
        if (gift && !canCheckout(cart)) throw new Error(GOBBI_EDITOR.text('Subscriptions in this bag are not ready for checkout from this draft. Remove them to continue with a one-time order.'));
        return cart;
      } catch (cause) {
        busy = false;
        checkoutLocked = false;
        error = cause.message;
        publish();
        throw cause;
      }
    }
    function releaseCheckout() {
      if (checkoutLocked) {
        busy = false;
        checkoutLocked = false;
        publish();
      }
    }
    return {
      read,
      add,
      remove,
      setQuantity,
      prepareCheckout,
      releaseCheckout,
      snapshot,
      isManagedGift,
      isGiftLine,
      root: base
    };
  }
  function createKlaviyoForms({config = {}, request = GOBBI_LIFECYCLE.fetch} = {}) {
    let busy = false;
    const publicId = value => typeof value === 'string' && (/^[a-zA-Z0-9]{6}$/).test(value);
    function ready(kind, product) {
      if (config.enabled !== true || !publicId(config.siteId)) return false;
      // The welcome offer is paused until its email sequence is connected.
      if (kind === 'welcome') return false;
      return config.backInStockListRoutingVerified === true && Number.isSafeInteger(Number(product?.variantId)) && Number(product.variantId) > 0 && publicId(config.backInStockListsByVariant?.[String(product.variantId)]);
    }
    async function post(path, data) {
      const response = await request('https://a.klaviyo.com/client/' + path + '/?company_id=' + encodeURIComponent(config.siteId), {
        method: 'POST',
        credentials: 'omit',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/vnd.api+json',
          revision: '2026-07-15'
        },
        body: JSON.stringify({
          data
        })
      });
      if (response.status !== 202) throw new Error(GOBBI_EDITOR.text(response.status === 429 ? 'Too many requests. Please wait a moment before trying again.' : 'Your signup was not confirmed. Please try again.'));
    }
    function listData(email, listId, source, properties = {}) {
      return {
        type: 'subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email,
                properties
              }
            }
          },
          custom_source: source
        },
        relationships: {
          list: {
            data: {
              type: 'list',
              id: listId
            }
          }
        }
      };
    }
    async function submit(kind, email, product) {
      if (busy) throw new Error(GOBBI_EDITOR.text('Your signup is still being submitted.'));
      if (!ready(kind, product)) throw new Error(GOBBI_EDITOR.text('Email signup is not connected yet. No email was submitted.'));
      const address = String(email || '').trim();
      if (!(/^[^\s@]+@[^\s@]+\.[^\s@]+$/).test(address)) throw new Error(GOBBI_EDITOR.text('Enter a valid email address.'));
      busy = true;
      try {
        if (kind === 'welcome') {
          await post('subscriptions', listData(address, config.welcomeListId, 'GOBBi welcome offer'));
        } else {
          await post('back-in-stock-subscriptions', {
            type: 'back-in-stock-subscription',
            attributes: {
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: address
                  }
                }
              },
              channels: ['EMAIL']
            },
            relationships: {
              variant: {
                data: {
                  type: 'catalog-variant',
                  id: '$shopify:::$default:::' + product.variantId
                }
              }
            }
          });
        }
        return {
          accepted: true,
          kind
        };
      } catch (error) {
        if (error instanceof TypeError) throw new Error(GOBBI_EDITOR.text('We could not confirm your signup. Check your connection before trying again.'));
        throw error;
      } finally {
        busy = false;
      }
    }
    return {
      ready,
      submit
    };
  }
  function nativeEscape(value) {
    return String(value ?? '').replace(/[&<>"']/g, char => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;'
    })[char]);
  }
  function nativeDisplayName(product) {
    // The global per-SKU catalog label is consistent across every page.
    return product.name;
  }
  function nativeURL(value) {
    try {
      const url = new URL(value, location.origin);
      return ['http:', 'https:'].includes(url.protocol) ? nativeEscape(url.href) : '#';
    } catch {
      return '#';
    }
  }
  let nativeLastShippingRatio = 0;
  function nativeGiftLine(item) {
    const config = nativeConfig?.subscriptionGift;
    return !!config && item.variant_id === config.variantId && ['_appstle_parent_product', '_appstle_parent_selling_plan', '_appstle_free_product', '_gobbi_subscription_gift'].some(key => Object.prototype.hasOwnProperty.call(item.properties || ({}), key));
  }
  function nativeManagedGift(item, cart = nativeCart.snapshot().cart) {
    const config = nativeConfig?.subscriptionGift;
    return nativeGiftLine(item) && cart?.items.some(parent => parent.quantity > 0 && config.qualifyingVariantIds?.includes(parent.variant_id) && config.qualifyingPlanIds?.includes(parent.selling_plan_allocation?.selling_plan?.id) && String(item.properties._appstle_parent_product) === String(parent.variant_id) && String(item.properties._appstle_parent_selling_plan) === String(parent.selling_plan_allocation.selling_plan.id));
  }
  function nativeGiftIsFree(item) {
    return nativeManagedGift(item) && item.quantity === 1 && !item.selling_plan_allocation && !item.selling_plan && item.final_line_price === 0 && (item.final_price === undefined || item.final_price === 0);
  }
  function nativeCartCheckoutAllowed(cart) {
    const gift = nativeConfig?.subscriptionGift;
    const subscriptionReady = nativeConfig.subscriptionsEnabled && nativeConfig.giftBackendVerified;
    const giftReady = gift?.enabled === true && gift?.backendVerified === true && gift?.strategy === 'appstle';
    const hasQualifyingSubscription = cart.items.some(item => gift?.qualifyingVariantIds?.includes(item.variant_id) && gift?.qualifyingPlanIds?.includes(item.selling_plan_allocation?.selling_plan?.id));
    return (!cart.items.some(item => item.selling_plan_allocation) || subscriptionReady) && (!(hasQualifyingSubscription || cart.items.some(nativeGiftLine)) || giftReady);
  }
  function nativeShippingState(cart, {busy = false, stale = false} = {}) {
    const items = cart.items || [], hasSubscriptions = items.some(item => item.selling_plan_allocation);
    // Shopify's cart total includes line and order discounts, all purchase types,
    // and a confirmed free thermos at zero. Shipping and tax are not included.
    const subtotal = Number.isSafeInteger(cart.total_price) && cart.total_price >= 0 ? cart.total_price : null;
    const showProgress = !items.length || items.some(item => !item.gift_card && item.requires_shipping !== false);
    const known = cart.currency === 'USD' && subtotal !== null && !busy && !stale;
    return {
      hasSubscriptions,
      showProgress,
      known,
      busy,
      subtotal,
      threshold: 5000,
      remaining: known ? Math.max(0, 5000 - subtotal) : null,
      ratio: known ? Math.min(1, subtotal / 5000) : 0
    };
  }
  function nativeShippingMarkup(shipping, price) {
    if (!shipping.showProgress) return '';
    const scope = $('#bag-content');
    if (!shipping.known) return '<div class="bag-shipping-status" data-gobbi-copy-final>' + (shipping.busy ? '<p class="bag-shipping-message" role="status">' + copyHTML('Updating your shipping progress…', [], scope) + '</p>' : '') + '<p class="bag-shipping-policy">' + copyHTML('Free shipping on orders of US$50+ after discounts. Shipping is charged below US$50.', [], scope) + '</p></div>';
    const message = shipping.remaining ? copy('Add {value_1} more for free shipping.', [price(shipping.remaining)], scope) : copy('You’ve unlocked free shipping!', [], scope);
    const details = copy('Order subtotal after discounts: {value_1} / {value_2}', [price(shipping.subtotal), price(shipping.threshold)], scope);
    return `<div class="bag-shipping-status${shipping.remaining ? '' : ' is-unlocked'}" data-gobbi-copy-final><p class="bag-shipping-message" role="status">${nativeEscape(message)}</p><div class="bag-shipping-track" role="progressbar" aria-label="${copyHTML('Free shipping progress', [], scope)}" aria-valuemin="0" aria-valuemax="${shipping.threshold}" aria-valuenow="${Math.min(shipping.subtotal, shipping.threshold)}" aria-valuetext="${nativeEscape(details)}"><span class="bag-shipping-fill" data-shipping-ratio="${shipping.ratio}" style="transform:scaleX(${nativeLastShippingRatio})"></span></div><p class="bag-shipping-detail">${nativeEscape(details)}</p></div>`;
  }
  function animateNativeShipping(content) {
    const fill = content.querySelector('[data-shipping-ratio]');
    if (!fill) return;
    const ratio = Number(fill.dataset.shippingRatio);
    requestAnimationFrame(() => requestAnimationFrame(() => {
      if (fill.isConnected) {
        fill.style.transform = 'scaleX(' + ratio + ')';
        nativeLastShippingRatio = ratio;
      }
    }));
  }
  function updateNativePurchaseUI(q) {
    const busy = nativeCart.snapshot().busy;
    const selected = isProduct ? slotsToSelection(state.mix) : state.selection;
    const sub = quote(selected, 'subscription', state.months, false);
    const once = quote(selected, 'once', state.months, false);
    const missing = state.mode === 'subscription' && !q.plansAvailable;
    if (missing) {
      for (const selector of ['[data-total]', '[data-unit]', '[data-discount]']) setText(selector, 'Unavailable');
    }
    setText('[data-plan-sub-price]', sub.plansAvailable ? money(sub.total) : 'Coming soon');
    if (isBuilder) {
      const prices = [...new Set(catalog.filter(p => p.available).map(p => p.price))];
      setText('[data-plan-once-price]', prices.length === 1 ? '{value_1} / box' : 'Priced by flavor', [money(prices[0])]);
    } else if (isProduct) setText('[data-plan-once-price]', money(once.total));
    setText('[data-recurring]', missing ? 'Coming soon' : state.mode === 'subscription' ? '{value_1} {value_2}, plus any applicable shipping and tax. Free US Economy shipping on orders of $50+ after discounts. Shipping is charged below $50. Shopify confirms recurring terms before payment.' : 'One-time purchase. Shipping, tax and eligible discounts are confirmed at checkout.', [money(q.total), intervalText(state.months)]);
    setText('[data-merch-plan]', state.mode === 'subscription' ? 'Coming soon' : 'One-time purchase. Final prices and eligible discounts are confirmed by Shopify.');
    $$('input[value="subscription"][name="purchase"], input[value="subscription"][name="merch-purchase"]').forEach(input => input.disabled = !nativeConfig.subscriptionsEnabled || !nativeConfig.giftBackendVerified);
    $$('[data-gift]').forEach(element => element.hidden = true);
    for (const selector of ['#builder-add', '#product-add']) {
      const button = $(selector);
      if (!button) continue;
      if (q.stockAvailable && !q.plansAvailable) {
        button.textContent = GOBBI_EDITOR.text('Coming soon', button);
        button.disabled = true;
      } else if (!q.stockAvailable && isProduct) {
        button.textContent = GOBBI_EDITOR.text('Out of stock · Notify me', button);
        button.disabled = busy;
      } else button.disabled = busy || !q.canPurchase;
    }
    $$('[data-card]').forEach(card => {
      const p = byId(card.dataset.card), line = quote({
        [p.id]: 1
      }, state.mode, state.months, false);
      if (!line.plansAvailable) {
        card.querySelector('[data-card-price]').textContent = GOBBI_EDITOR.text('Coming soon', card.querySelector('[data-card-price]'));
        card.querySelector('[data-card-unit]').textContent = GOBBI_EDITOR.text('Choose one-time purchase', card.querySelector('[data-card-unit]'));
      }
    });
    $$('[data-slot-price]').forEach(element => {
      const line = quote({
        [state.mix[Number(element.dataset.slotPrice)]]: 1
      }, state.mode, state.months, false);
      if (!line.plansAvailable) element.textContent = GOBBI_EDITOR.text('Coming soon', element);
    });
    $$('[data-merch-card]').forEach(card => {
      const p = byId(card.dataset.merchCard), line = quote({
        [p.id]: 1
      }, state.mode, state.months, false), button = card.querySelector('[data-quick-add]');
      button.disabled = busy || p.available && !line.plansAvailable;
      if (!line.plansAvailable) {
        card.querySelector('[data-merch-price]').textContent = GOBBI_EDITOR.text('Coming soon', card.querySelector('[data-merch-price]'));
        card.querySelector('[data-merch-unit]').textContent = GOBBI_EDITOR.text('Choose one-time purchase', card.querySelector('[data-merch-unit]'));
        if (p.available) button.textContent = GOBBI_EDITOR.text('Coming soon', button);
      }
    });
  }
  let pendingBagRecommendation = null;
  function bagRecommendedProducts(cart) {
    if (!cart || cart.currency !== nativeConfig.currency) return [];
    const inBag = new Set(cart.items.map(item => Number(item.variant_id)));
    return catalog.filter(product => product.available && product.stock > 0 && !product.requiresSellingPlan && Number.isSafeInteger(Number(product.variantId)) && Number(product.variantId) > 0 && Number.isSafeInteger(product.price) && product.price >= 0 && !inBag.has(Number(product.variantId))).slice(0, 3);
  }
  function bagRecommendationsMarkup(cart, busy, stale, price) {
    const products = bagRecommendedProducts(cart), scope = $('#bag-content');
    if (!products.length) return '';
    return '<section class="bag-recommendations" aria-labelledby="bag-recommendations-title" data-gobbi-copy-final><h3 id="bag-recommendations-title">' + copyHTML('You may also like', [], scope) + '</h3><div class="bag-recommendation-list">' + products.map(product => {
      const name = nativeDisplayName(product);
      const family = copy(product.family === 'focus' ? 'Focus Broth' : 'Energy Broth', [], scope);
      const adding = pendingBagRecommendation === product.id;
      return `<article class="bag-recommendation"><a class="bag-recommendation-image" href="${nativeURL(product.url)}" aria-label="${nativeEscape(name + ' ' + family)}"><img src="${nativeURL(product.image)}" alt="" width="96" height="96" loading="lazy"></a><div class="bag-recommendation-copy"><a href="${nativeURL(product.url)}">${nativeEscape(name)}</a><p>${copyHTML('{value_1} · {value_2} sticks', [family, product.sticks], scope)}</p><p>${copyHTML('One-time purchase', [], scope)}</p><strong>${price(product.price)}</strong></div><button type="button" class="button outline bag-recommendation-add" data-recommendation-add="${nativeEscape(product.id)}" aria-label="${copyHTML('Add {value_1} {value_2} to cart as a one-time purchase', [name, family], scope)}" ${busy || stale ? 'disabled' : ''}>${copyHTML(adding ? 'Adding…' : 'Add to cart', [], scope)}</button></article>`;
    }).join('') + '</div></section>';
  }
  function bindBagRecommendations() {
    $$('[data-recommendation-add]').forEach(button => button.addEventListener('click', async () => {
      const snapshot = nativeCart.snapshot();
      if (snapshot.busy || snapshot.stale || !snapshot.cart) return;
      const product = bagRecommendedProducts(snapshot.cart).find(product => product.id === button.dataset.recommendationAdd);
      if (!product) return;
      const restoreFocus = document.activeElement === button;
      const scrollTop = $('#bag-content .bag-scroll')?.scrollTop || 0;
      pendingBagRecommendation = product.id;
      button.disabled = true;
      try {
        await nativeCart.add([{id: Number(product.variantId), quantity: 1}]);
        toast(copy('{value_1} added to your bag.', [nativeDisplayName(product)], $('#toast')), true);
      } catch (error) {
        toast(error.message, true);
      } finally {
        pendingBagRecommendation = null;
        if (GOBBI_LIFECYCLE.active) {
          renderNativeBag();
          const scroll = $('#bag-content .bag-scroll');
          if (scroll) scroll.scrollTop = scrollTop;
          if (restoreFocus && document.activeElement === document.body) {
            const next = $('#refresh-native-bag') || $('[data-recommendation-add]') || $('#native-checkout-form button') || $('#bag-title');
            next?.focus({preventScroll: true});
          }
        }
      }
    }, GOBBI_LIFECYCLE.options()));
  }
  function renderNativeBag() {
    if (!GOBBI_LIFECYCLE.active) return;
    const {cart, busy, stale, error} = nativeCart.snapshot();
    const content = $('#bag-content');
    $('#bag-count').textContent = GOBBI_EDITOR.text(cart?.item_count || 0, $('#bag-count'));
    if (!cart) {
      content.innerHTML = GOBBI_EDITOR.html('<div class="bag-scroll bag-empty"><p>Your Shopify bag has not loaded yet.</p><button type="button" class="button outline" id="refresh-native-bag">Refresh bag</button></div>', content);
      bindNativeRefresh();
      return;
    }
    const blockedSubscription = !nativeCartCheckoutAllowed(cart);
    const price = value => new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: cart.currency
    }).format(value / 100);
    const shippingState = nativeShippingState(cart, {
      busy,
      stale
    }), shipping = nativeShippingMarkup(shippingState, price);
    if (!shippingState.showProgress) nativeLastShippingRatio = 0;
    const shippingTop = shipping ? '<div class="bag-shipping-top">' + shipping + '</div>' : '';
    const recommendations = bagRecommendationsMarkup(cart, busy, stale, price);
    const subscriptionNotice = blockedSubscription ? '<p class="checkout-notice" role="status">Subscriptions in this bag are not ready for checkout from this draft. Remove them to continue with a one-time order.</p>' : '';
    const message = error ? `<p class="checkout-notice" role="alert" data-gobbi-copy-final>${nativeEscape(error)}</p>` : '';
    const refresh = stale ? '<p>Your last update needs to be checked with Shopify.</p><button type="button" class="button outline" id="refresh-native-bag">Refresh bag</button>' : '';
    if (!cart.items.length) {
      content.innerHTML = GOBBI_EDITOR.html(shippingTop + '<div class="bag-scroll bag-empty">' + message + refresh + '<div class="bag-empty-intro"><p>Your bag is ready for something savory.</p><a class="button primary wide" href="' + nativeEscape(nativeCart.root) + 'collections/all">Shop all →</a></div>' + recommendations + '</div>', content);
      animateNativeShipping(content);
      bindNativeRefresh();
      bindBagRecommendations();
      return;
    }
    const renderLine = item => {
      const p = catalog.find(p => Number(p.variantId) === item.variant_id), plan = item.selling_plan_allocation?.selling_plan, managedGift = nativeGiftLine(item);
      const perStick = p ? ' ' + copyHTML('· {value_1} / stick', [price(item.final_line_price / (item.quantity * p.sticks))], content) : '';
      const discounts = (item.discounts || []).map(d => nativeEscape(d.title)).join(', ');
      const giftLabel = managedGift ? `<p>${copyHTML(nativeGiftIsFree(item) ? 'Free thermos · first delivery only' : 'Thermos discount awaiting confirmation', [], content)}</p>` : '';
      const controls = managedGift ? `<span class="bag-line-quantity" aria-label="${copyHTML('Gift quantity: {value_1}', [item.quantity], content)}">${item.quantity}</span>` : `<div class="bag-quantity-stepper" role="group" aria-label="${copyHTML('Quantity for {value_1}', [item.product_title], content)}"><button type="button" data-native-quantity="${nativeEscape(item.key)}" data-quantity-step="-1" aria-label="${copyHTML('Decrease quantity of {value_3}', [item.product_title], content)}" ${busy || stale ? 'disabled' : ''}>−</button><span class="bag-line-quantity" aria-label="${copyHTML('Quantity: {value_5}', [item.quantity], content)}" aria-live="polite" aria-atomic="true">${item.quantity}</span><button type="button" data-native-quantity="${nativeEscape(item.key)}" data-quantity-step="1" aria-label="${copyHTML('Increase quantity of {value_8}', [item.product_title], content)}" ${busy || stale ? 'disabled' : ''}>+</button></div>`;
      const unit = copy(p ? (item.quantity === 1 ? 'box' : 'boxes') : (item.quantity === 1 ? 'item' : 'items'), [], content);
      return `<article class="bag-line" data-gobbi-copy-final>${item.image ? `<a href="${nativeURL(item.url)}"><img src="${nativeURL(item.image)}" alt="${nativeEscape(item.product_title)}"></a>` : '<span></span>'}<div class="bag-line-copy"><h3>${nativeEscape(item.product_title)}</h3><p>${copyHTML('{value_3} · {value_4} {value_5}', [item.variant_title || '', item.quantity, unit], content)}</p><p>${price(item.final_line_price)}${perStick}</p><p>${plan ? nativeEscape(plan.name) : copyHTML('One-time purchase', [], content)}</p>${giftLabel}${discounts ? `<small>${discounts}</small>` : ''}</div><div class="bag-line-actions">${controls}</div></article>`;
    };
    const oneTimeItems = cart.items.filter(item => !item.selling_plan_allocation), subscriptionItems = cart.items.filter(item => item.selling_plan_allocation);
    const renderGroup = (items, title, id, intro) => {
      if (!items.length) return '';
      const count = items.reduce((sum, item) => sum + item.quantity, 0);
      return `<section class="plan-group bag-purchase-group" aria-labelledby="${id}"><header data-gobbi-copy-final><strong id="${id}">${copyHTML(title, [], content)}</strong><small>${copyHTML('{value_4} {value_5}', [count, copy(count === 1 ? 'item' : 'items', [], content)], content)}</small></header>${intro}${items.map(renderLine).join('')}</section>`;
    };
    const groups = renderGroup(oneTimeItems, 'One-time purchases', 'bag-one-time-heading', '') + renderGroup(subscriptionItems, 'Subscription', 'bag-subscription-heading', '<p class="bag-subscription-shipping">Each subscription renewal qualifies for free US Economy shipping at $50+ after discounts. Shipping is charged below $50.</p>');
    const discounts = (cart.cart_level_discount_applications || []).map(d => `<p data-gobbi-copy-final>${copyHTML('{value_1}: −{value_2}', [d.title, price(d.total_allocated_amount)], content)}</p>`).join('');
    content.innerHTML = GOBBI_EDITOR.html(shippingTop + '<div class="bag-scroll">' + message + subscriptionNotice + refresh + groups + `${discounts}${recommendations}</div><div class="bag-checkout"><div class="bag-totals"><span>Subtotal</span><strong>${price(cart.total_price)}</strong></div><p class="bag-small">Shipping, taxes and eligible discounts are confirmed at checkout. Only items listed in this bag will be ordered.</p><form action="${nativeEscape(nativeCart.root)}cart" method="post" id="native-checkout-form"><button class="button primary wide" type="submit" name="checkout" ${busy || stale || blockedSubscription ? 'disabled' : ''}>Checkout with Shopify →</button></form></div>`, content);
    animateNativeShipping(content);
    $$('[data-native-quantity]').forEach(button => button.addEventListener('click', async () => {
      const key = button.dataset.nativeQuantity, step = Number(button.dataset.quantityStep), restoreFocus = document.activeElement === button;
      const position = $$('[data-native-quantity]').indexOf(button);
      try {
        const item = nativeCart.snapshot().cart?.items.find(item => item.key === key);
        if (!item) throw new Error(GOBBI_EDITOR.text('Refresh your bag before changing this quantity.'));
        await nativeCart.setQuantity(key, Math.max(0, item.quantity + step));
      } catch (error) {
        toast(error.message, true);
      }
      renderNativeBag();
      if (restoreFocus && document.activeElement === document.body) {
        const controls = $$('[data-native-quantity]');
        const next = $('#refresh-native-bag') || controls.find(node => node.dataset.nativeQuantity === key && Number(node.dataset.quantityStep) === step) || controls[Math.min(position, controls.length - 1)] || $('#bag-content .button');
        next?.focus({
          preventScroll: true
        });
      }
    }, GOBBI_LIFECYCLE.options()));
    $('#native-checkout-form').addEventListener('submit', async event => {
      event.preventDefault();
      if (nativeCart.snapshot().busy) return;
      const form = event.currentTarget;
      form.querySelector('button').disabled = true;
      try {
        await nativeCart.prepareCheckout();
        const submit = document.createElement('input');
        submit.type = 'hidden';
        submit.name = 'checkout';
        submit.value = 'Checkout';
        form.append(submit);
        document.body.append(form);
        form.hidden = true;
        HTMLFormElement.prototype.submit.call(form);
      } catch (error) {
        nativeCart.releaseCheckout();
        renderNativeBag();
        toast(error.message, true);
      }
    }, GOBBI_LIFECYCLE.options());
    bindNativeRefresh();
    bindBagRecommendations();
  }
  function bindNativeRefresh() {
    $('#refresh-native-bag')?.addEventListener('click', async () => {
      try {
        await nativeCart.read();
        renderNativeBag();
      } catch (error) {
        toast(error.message, true);
      }
    }, GOBBI_LIFECYCLE.options());
  }
  function bindNativeCartPage() {
    const form = $('[data-native-cart-page-form]');
    if (!form) return;
    form.addEventListener('submit', async event => {
      if (event.submitter?.name !== 'checkout') {
        if (form.querySelector('[data-native-cart-gift-quantity]')) {
          event.preventDefault();
          toast('Open your bag to update items in this subscription order.');
        }
        return;
      }
      event.preventDefault();
      if (nativeCart.snapshot().busy) return;
      const button = event.submitter;
      button.disabled = true;
      try {
        const changed = [...form.querySelectorAll('input[name="updates[]"]')].some(input => input.value !== input.defaultValue);
        if (changed) throw new Error(GOBBI_EDITOR.text('Save your quantity changes with Update bag before checkout.'));
        await nativeCart.prepareCheckout();
        if ([...form.querySelectorAll('input[name="updates[]"]')].some(input => input.value !== input.defaultValue)) throw new Error(GOBBI_EDITOR.text('Your quantities changed. Update your bag before checkout.'));
        const checkout = document.createElement('form');
        checkout.method = 'post';
        checkout.action = form.action;
        checkout.hidden = true;
        const submit = document.createElement('input');
        submit.name = 'checkout';
        submit.value = 'Checkout';
        checkout.append(submit);
        document.body.append(checkout);
        HTMLFormElement.prototype.submit.call(checkout);
      } catch (error) {
        nativeCart.releaseCheckout();
        button.disabled = false;
        toast(error.message, true);
      }
    }, GOBBI_LIFECYCLE.options());
  }
  async function addNativeQuote(q) {
    if (!q.canPurchase) {
      toast(q.stockAvailable ? 'Subscriptions are not ready yet. Choose a one-time purchase.' : 'Choose in-stock boxes before adding your delivery.');
      return;
    }
    const lines = q.lines.map(line => ({
      id: Number(line.product.variantId),
      quantity: line.quantity,
      ...q.mode === 'subscription' ? {
        selling_plan: line.sellingPlanId
      } : {}
    }));
    try {
      await nativeCart.add(lines);
      renderNativeBag();
      openBagDrawer();
    } catch (error) {
      renderNativeBag();
      openBagDrawer();
      toast(error.message, true);
    }
  }
  const $ = selector => document.querySelector(selector);
  const $$ = selector => [...document.querySelectorAll(selector)];
  const key = 'gobbi-design-v2';
  const nativeConfig = globalThis.GOBBI_SHOPIFY?.enabled === true ? globalThis.GOBBI_SHOPIFY : null;
  const emailForms = createKlaviyoForms({
    config: nativeConfig?.klaviyo
  });
  let notifyProduct = null, notifyVersion = 0;
  let saved = {};
  try {
    saved = JSON.parse(sessionStorage.getItem(key) || '{}') || ({});
  } catch {}
  const isProduct = document.body.dataset.page === 'product' && !!document.getElementById('product-add');
  const isBuilder = document.body.dataset.page === 'home' && !!document.getElementById('builder-add');
  const product = byId(document.body.dataset.product);
  const params = new URLSearchParams(location.search);
  const modeValue = params.get('purchase') || saved.mode;
  const monthsValue = Number(params.get('months') || saved.months);
  const quantityValue = Number(params.get('boxes') || saved.quantity);
  const state = {
    selection: saved.selection ? normalizeSelection(saved.selection) : {
      varietypack: 1,
      tomatoharvest: 1,
      mightymushroom: 1
    },
    mode: ['once', 'subscription'].includes(modeValue) ? modeValue : nativeConfig ? 'once' : 'subscription',
    months: [1, 2, 3].includes(monthsValue) ? monthsValue : 1,
    quantity: [1, 2, 3].includes(quantityValue) ? quantityValue : 1,
    welcome: false,
    filter: 'energy',
    cart: []
  };
  if (!nativeConfig && Array.isArray(saved.cart)) {
    for (const item of saved.cart) {
      if (byId(item.id)?.available && Number.isInteger(item.quantity) && item.quantity > 0 && item.quantity <= byId(item.id).stock && ['once', 'subscription'].includes(item.mode) && [1, 2, 3].includes(item.months)) state.cart.push({
        id: item.id,
        quantity: item.quantity,
        mode: item.mode,
        months: item.months
      });
    }
  }
  function persist() {
    try {
      sessionStorage.setItem(key, JSON.stringify(nativeConfig ? {
        ...state,
        cart: [],
        welcome: false
      } : state));
    } catch {}
  }
  const nativeCart = nativeConfig ? createShopifyCart({
    root: nativeConfig.root,
    subscriptionGift: nativeConfig.subscriptionGift,
    canCheckout: cart => nativeCartCheckoutAllowed(cart),
    onChange: () => {
      update();
      if ($('#bag-dialog').open) renderBag();
    }
  }) : null;
  if (isProduct) {
    const urlMix = params.get('mix')?.split(',').filter(id => byId(id));
    const storedMix = saved.mixProduct === product.id ? saved.mix : [];
    state.mix = resizeSlots(urlMix?.length ? urlMix : storedMix, state.quantity, product.id);
    state.mixProduct = product.id;
  }
  function currentQuote() {
    return quote(isProduct ? slotsToSelection(state.mix) : state.selection, state.mode, state.months, state.welcome);
  }
  function updateFlavorAvailability() {
    $$('.flavor-pill[data-flavor-link]').forEach(link => {
      const handle = new URL(link.href, location.origin).pathname.split('/').filter(Boolean).at(-1);
      const flavor = byId(handle);
      link.querySelector('[data-flavor-stock]')?.remove();
      if (!flavor || flavor.available) return;
      const status = document.createElement('span');
      status.dataset.flavorStock = '';
      status.textContent = ' ' + copy('— Out of stock', [], link);
      link.append(status);
    });
  }
  function renderSlots() {
    if (!isProduct) return;
    updateFlavorAvailability();
    $('#box-slots').innerHTML = GOBBI_EDITOR.html(state.mix.map((id, index) => {
      const selected = byId(id);
      const options = ['energy', 'focus'].map(family => `<optgroup label="${copyHTML(family === 'energy' ? 'Energy Broth' : 'Focus Broth', [], $('#box-slots'))}">${catalog.filter(p => p.family === family).map(p => `<option value="${nativeEscape(p.id)}" ${p.id === id ? 'selected' : ''}>${nativeEscape(p.name + (p.available ? '' : ' ' + copy('— Out of stock', [], $('#box-slots'))))}</option>`).join('')}</optgroup>`).join('');
      return `<div class="mix-slot" data-gobbi-copy-final><img src="${nativeURL(selected.image)}" alt=""><div><label for="box-slot-${index}">${copyHTML('Box {value_3} · {value_4}', [index + 1, copy(selected.family === 'energy' ? 'Energy' : 'Focus', [], $('#box-slots'))], $('#box-slots'))}</label><select id="box-slot-${index}" data-box-slot="${index}">${options}</select></div><p class="mix-slot-price" data-slot-price="${index}"></p></div>`;
    }).join(''), $('#box-slots'));
    $$('[data-box-slot]').forEach(select => select.addEventListener('change', () => {
      const next = byId(select.value);
      if (!next) return;
      state.mix[Number(select.dataset.boxSlot)] = next.id;
      renderSlots();
      update();
    }, GOBBI_LIFECYCLE.options()));
  }
  let toastTimer;
  function toast(message, final = false) {
    if (!GOBBI_LIFECYCLE.active) return;
    clearTimeout(toastTimer);
    $('#toast').textContent = final ? String(message ?? '') : GOBBI_EDITOR.text(message, $('#toast'));
    $('#toast').hidden = false;
    toastTimer = GOBBI_LIFECYCLE.timeout(() => {
      $('#toast').hidden = true;
    }, 4500);
  }
  function openNotify(id) {
    const chosen = byId(id), family = chosen?.family === 'energy' ? 'Energy' : 'Focus';
    notifyProduct = chosen;
    notifyVersion++;
    $('#notify-form-status').textContent = GOBBI_EDITOR.text('', $('#notify-form-status'));
    $('#notify-dialog .eyebrow').textContent = copy('{value_1} BROTH · OUT OF STOCK', [copy(family).toUpperCase()], $('#notify-dialog .eyebrow'));
    $('#notify-product').textContent = copy('Get notified when {value_2} Broth is available.', [(chosen ? chosen.name + ' ' : '') + copy(family)], $('#notify-product'));
    $('#notify-form small').textContent = GOBBI_EDITOR.text(emailForms.ready('restock', chosen) ? 'We’ll email you when this flavor is back in stock. This does not sign you up for general marketing emails.' : 'Email signup is not connected yet. No email will be submitted.', $('#notify-form small'));
    $('#notify-form').hidden = false;
    $('#notify-success').hidden = true;
    $('#notify-dialog').showModal();
  }
  function setText(selector, value, values) {
    $$(selector).forEach(element => element.textContent = values ? copy(value, values, element) : GOBBI_EDITOR.text(value, element));
  }
  function updateShippingOffers() {
    $$('[data-shipping-offer]').forEach(offer => {
      const title = offer.querySelector('[data-shipping-offer-title]');
      const detail = offer.querySelector('[data-shipping-offer-detail]');
      if (title) title.textContent = GOBBI_EDITOR.text('Free shipping on $50+.', title);
      if (detail) {
        detail.textContent = GOBBI_EDITOR.text('Free US Economy shipping on orders of $50+ after discounts. Shipping is charged below $50. Tax calculated at checkout.', detail);
        detail.hidden = state.mode === 'once';
      }
    });
  }
  function update() {
    if (!GOBBI_LIFECYCLE.active) return;
    const q = currentQuote();
    $$('input[name="purchase"], input[name="merch-purchase"]').forEach(input => input.checked = input.value === state.mode);
    $$('input[name="cadence"]').forEach(input => input.checked = Number(input.value) === state.months);
    $$('input[name="quantity"]').forEach(input => input.checked = Number(input.value) === state.quantity);
    setText('[data-box-count]', q.boxes);
    setText('[data-stick-count]', q.sticks);
    setText('[data-base]', money(q.base));
    setText('[data-total]', money(q.total));
    setText('[data-discount]', '−' + money(q.savings));
    setText('[data-discount-label]', state.mode === 'subscription' ? 'Subscription savings · 20%' : state.welcome ? 'Welcome savings · 20%' : 'Savings');
    setText('[data-total-label]', state.mode === 'subscription' ? 'Every delivery' : 'One-time total');
    setText('[data-unit]', money(q.sticks ? q.total / q.sticks : 0));
    setText('[data-recurring]', isProduct && !q.canPurchase ? 'Your selected plan is a preview. Availability is shown on the purchase button below.' : q.boxes ? state.mode === 'subscription' ? '{value_1} today, then {value_2} {value_3}, plus any applicable shipping and tax. Free US Economy shipping on orders of $50+ after discounts. Shipping is charged below $50. Your thermos is included with the first subscription delivery only.' : 'A one-time purchase. No recurring charges.' : 'Choose your first box to see your delivery total.', [money(q.total), money(q.total), intervalText(state.months)]);
    updateShippingOffers();
    $$('[data-cadence-block]').forEach(element => element.hidden = state.mode !== 'subscription');
    $$('[data-gift]').forEach(element => element.hidden = !q.gift);
    if (isProduct) {
      setText('[data-plan-sub-price]', money(quote(slotsToSelection(state.mix), 'subscription', state.months).total));
      setText('[data-plan-once-price]', money(quote(slotsToSelection(state.mix), 'once', state.months, state.welcome).total));
      $$('[data-slot-price]').forEach(element => {
        const p = byId(state.mix[Number(element.dataset.slotPrice)]), line = quote({
          [p.id]: 1
        }, state.mode, state.months, state.welcome);
        element.textContent = copy('{value_1} / box · {value_2} / stick', [money(line.total), money(line.total / p.sticks)], element);
      });
      const button = $('#product-add');
      button.disabled = false;
      button.textContent = copy(!q.canPurchase ? 'Out of stock · Notify me' : state.mode === 'subscription' ? 'Subscribe & save — {value_1}' : 'Add to bag — {value_1}', [money(q.total)], button);
      $$('[data-flavor-link]').forEach(link => {
        const url = new URL(link.getAttribute('href'), location.origin);
        url.searchParams.set('boxes', state.quantity);
        url.searchParams.set('purchase', state.mode);
        url.searchParams.set('months', state.months);
        const target = catalog.find(p => p.url === url.pathname);
        if (target) {
          const nextMix = [...state.mix];
          nextMix[0] = target.id;
          url.searchParams.set('mix', nextMix.join(','));
        }
        link.href = url.pathname + url.search;
      });
      const url = new URL(location.href);
      url.searchParams.set('boxes', state.quantity);
      url.searchParams.set('purchase', state.mode);
      url.searchParams.set('months', state.months);
      url.searchParams.set('mix', state.mix.join(','));
      history.replaceState(null, '', url.pathname + url.search + url.hash);
    } else if (isBuilder) {
      setText('[data-plan-sub-price]', '$14.40 / box');
      setText('[data-plan-once-price]', state.welcome ? '$14.40 / box' : '$18.00 / box');
      const button = $('#builder-add');
      button.disabled = !q.canPurchase;
      button.textContent = copy(!q.boxes ? 'Choose your first box' : state.mode === 'subscription' ? 'Subscribe & save — {value_1}' : 'Add to bag — {value_1}', [money(q.total)], button);
      $$('[data-count]').forEach(element => element.textContent = GOBBI_EDITOR.text(state.selection[element.dataset.count] || 0, element));
      $$('[data-minus]').forEach(button => button.disabled = !(state.selection[button.dataset.minus] > 0));
      $$('[data-plus]').forEach(button => button.disabled = (state.selection[button.dataset.plus] || 0) >= byId(button.dataset.plus).stock);
      $$('[data-card]').forEach(card => {
        const selected = (state.selection[card.dataset.card] || 0) > 0;
        card.classList.toggle('is-selected', selected);
      });
      $('#selected-boxes').innerHTML = GOBBI_EDITOR.html(q.lines.length ? q.lines.map(line => `<div class="selected-line" data-gobbi-copy-final><img src="${nativeURL(line.product.image)}" alt=""><span><strong>${nativeEscape(nativeDisplayName(line.product))}</strong><small>${copyHTML('{value_3} · {value_4} {value_5}', [copy(line.product.family === 'energy' ? 'Energy' : 'Focus'), line.quantity, copy(line.quantity === 1 ? 'box' : 'boxes')], $('#selected-boxes'))}</small></span><button type="button" data-remove-selection="${nativeEscape(line.product.id)}" aria-label="${copyHTML('Remove {value_7} from delivery', [nativeDisplayName(line.product)], $('#selected-boxes'))}">×</button></div>`).join('') : '<p class="empty-selection">Add your favorite flavors to get started.</p>', $('#selected-boxes'));
      $$('[data-remove-selection]').forEach(button => button.addEventListener('click', () => {
        delete state.selection[button.dataset.removeSelection];
        update();
      }, GOBBI_LIFECYCLE.options()));
      $$('[data-card]').forEach(card => {
        const p = byId(card.dataset.card), line = quote({
          [p.id]: 1
        }, state.mode, state.months, state.welcome);
        card.querySelector('[data-card-price]').innerHTML = GOBBI_EDITOR.html(`${money(line.total)} <em>/ box</em>`, card.querySelector('[data-card-price]'));
        card.querySelector('[data-card-unit]').textContent = copy('{value_1} / stick', [money(line.total / p.sticks)], card.querySelector('[data-card-unit]'));
      });
    }
    updateMerch();
    $('#bag-count').textContent = GOBBI_EDITOR.text(nativeCart ? nativeCart.snapshot().cart?.item_count || 0 : state.cart.reduce((count, item) => count + item.quantity, 0), $('#bag-count'));
    if (nativeCart) updateNativePurchaseUI(q);
    persist();
  }
  function filterFamily(family) {
    state.filter = family;
    $$('[data-card]').forEach(card => card.hidden = family !== 'all' && card.dataset.family !== family);
    $$('[data-filter]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.filter === family)));
  }
  $$('[data-intro-family]').forEach(link => link.addEventListener('click', () => filterFamily(link.dataset.introFamily), GOBBI_LIFECYCLE.options()));
  $$('[data-filter]').forEach(button => button.addEventListener('click', () => filterFamily(button.dataset.filter), GOBBI_LIFECYCLE.options()));
  $$('[data-plus]').forEach(button => button.addEventListener('click', () => {
    const id = button.dataset.plus, p = byId(id);
    if (p.available) state.selection[id] = Math.min((state.selection[id] || 0) + 1, p.stock);
    update();
  }, GOBBI_LIFECYCLE.options()));
  $$('[data-minus]').forEach(button => button.addEventListener('click', () => {
    const id = button.dataset.minus;
    state.selection[id] = Math.max((state.selection[id] || 0) - 1, 0);
    if (!state.selection[id]) delete state.selection[id];
    update();
  }, GOBBI_LIFECYCLE.options()));
  $$('[data-notify]').forEach(button => button.addEventListener('click', () => openNotify(button.dataset.notify), GOBBI_LIFECYCLE.options()));
  $$('input[name="purchase"], input[name="merch-purchase"]').forEach(input => input.addEventListener('change', () => {
    state.mode = input.value;
    update();
  }, GOBBI_LIFECYCLE.options()));
  $$('input[name="cadence"]').forEach(input => input.addEventListener('change', () => {
    state.months = Number(input.value);
    update();
  }, GOBBI_LIFECYCLE.options()));
  $$('input[name="quantity"]').forEach(input => input.addEventListener('change', () => {
    state.quantity = Number(input.value);
    state.mix = resizeSlots(state.mix, state.quantity, product.id);
    renderSlots();
    update();
  }, GOBBI_LIFECYCLE.options()));
  const bagDrawer = $('#bag-dialog');
  let bagOpener, bagCloseTimer;
  function openBagDrawer() {
    clearTimeout(bagCloseTimer);
    bagDrawer.classList.remove('is-closing');
    if (!bagDrawer.open) {
      bagOpener = document.activeElement;
      bagDrawer.showModal();
    }
    document.body.classList.add('bag-is-open');
    $('#bag-title').focus({
      preventScroll: true
    });
  }
  function closeBagDrawer() {
    if (!bagDrawer.open || bagDrawer.classList.contains('is-closing')) return;
    if (matchMedia('(prefers-reduced-motion:reduce)').matches) {
      bagDrawer.close();
      return;
    }
    bagDrawer.classList.add('is-closing');
    bagCloseTimer = GOBBI_LIFECYCLE.timeout(() => bagDrawer.close(), 200);
  }
  function closeDialog(dialog) {
    if (dialog === bagDrawer) closeBagDrawer(); else dialog.close();
  }
  bagDrawer.addEventListener('cancel', event => {
    event.preventDefault();
    closeBagDrawer();
  }, GOBBI_LIFECYCLE.options());
  bagDrawer.addEventListener('close', () => {
    clearTimeout(bagCloseTimer);
    bagDrawer.classList.remove('is-closing');
    document.body.classList.remove('bag-is-open');
    if (bagOpener?.isConnected) bagOpener.focus({
      preventScroll: true
    });
  }, GOBBI_LIFECYCLE.options());
  bagDrawer.addEventListener('click', event => {
    if (event.target.closest('a')) closeBagDrawer();
  }, GOBBI_LIFECYCLE.options());
  $$('[data-open]').forEach(button => button.addEventListener('click', () => document.getElementById(button.dataset.open).showModal(), GOBBI_LIFECYCLE.options()));
  $$('.dialog-close').forEach(button => button.addEventListener('click', () => closeDialog(button.closest('dialog')), GOBBI_LIFECYCLE.options()));
  $$('dialog').forEach(dialog => dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const r = dialog.getBoundingClientRect();
    if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) closeDialog(dialog);
  }, GOBBI_LIFECYCLE.options()));
  for (const name of ['notify']) {
    const status = document.createElement('p');
    status.id = name + '-form-status';
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    $('#' + name + '-form').append(status);
  }
  $('#notify-form').addEventListener('submit', async event => {
    event.preventDefault();
    const form = event.currentTarget;
    if (!form.reportValidity()) return;
    const button = form.querySelector('button'), status = $('#notify-form-status'), version = notifyVersion, chosen = notifyProduct;
    if (button.disabled) return;
    button.disabled = true;
    status.textContent = GOBBI_EDITOR.text('Submitting…', status);
    try {
      await emailForms.submit('restock', $('#notify-email').value, chosen);
      if (version === notifyVersion) {
        form.reset();
        form.hidden = true;
        $('#notify-success').textContent = copy('Restock signup received for {value_1}. Check your inbox and confirm your email if requested.', [chosen.name], $('#notify-success'));
        $('#notify-success').hidden = false;
        $('#notify-success').setAttribute('tabindex', '-1');
        $('#notify-success').focus();
      }
    } catch (error) {
      if (version === notifyVersion) status.textContent = String(error.message ?? '');
    } finally {
      button.disabled = false;
    }
  }, GOBBI_LIFECYCLE.options());
  function renderBag() {
    if (!GOBBI_LIFECYCLE.active) return;
    if (nativeCart) {
      renderNativeBag();
      return;
    }
    const q = cartQuote(state.cart, state.welcome);
    $('#bag-count').textContent = GOBBI_EDITOR.text(q.boxes, $('#bag-count'));
    if (!q.lines.length) {
      $('#bag-content').innerHTML = GOBBI_EDITOR.html('<div class="bag-scroll bag-empty"><p>Your bag is ready for something savory.</p><a class="button primary wide" href="/collections/all" style="margin-top:20px">Shop all →</a><p class="shipping-offer">Free US Economy shipping on one-time and subscription orders of $50+ after discounts. Shipping is charged below $50.</p></div>', $('#bag-content'));
      return;
    }
    const groups = groupCart(state.cart, state.welcome);
    $('#bag-content').innerHTML = GOBBI_EDITOR.html('<div class="bag-scroll"><p class="bag-shipping-banner">Free US Economy shipping on one-time and subscription orders of $50+ after discounts. Shipping is charged below $50, including subscription renewals.</p>' + groups.map(group => `<section class="plan-group"><header><div><strong>${group.mode === 'subscription' ? 'Your mixed subscription' : 'One-time delivery'}</strong><small data-gobbi-copy-final>${copyHTML('{value_2} {value_3} · {value_4}', [group.boxes, copy(group.boxes === 1 ? 'box' : 'boxes'), group.mode === 'subscription' ? intervalText(group.months) : copy('Delivered once')], $('#bag-content'))}</small></div><div><strong>${money(group.total)}</strong><small>${group.mode === 'subscription' ? 'per delivery' : 'one time'}</small></div></header>${group.items.map(item => {
      const p = byId(item.id), line = quote({
        [p.id]: item.quantity
      }, item.mode, item.months, state.welcome);
      return `<article class="bag-line" data-gobbi-copy-final><a href="${nativeURL(p.url)}"><img src="${nativeURL(p.image)}" alt="${nativeEscape(p.name + ' ' + copy(p.family === 'energy' ? 'Energy Broth' : 'Focus Broth'))}"></a><div><h3>${nativeEscape(p.name)}</h3><p>${copyHTML('{value_6} · {value_7} {value_8} · {value_9} sticks', [copy(p.family === 'energy' ? 'Energy' : 'Focus'), item.quantity, copy(item.quantity === 1 ? 'box' : 'boxes'), line.sticks], $('#bag-content'))}</p><p>${copyHTML('{value_10} · {value_11} / stick', [money(line.total), money(line.total / line.sticks)], $('#bag-content'))}</p></div><button type="button" data-remove-cart="${item.index}" aria-label="${copyHTML('Remove {value_13} from bag', [p.name], $('#bag-content'))}">×</button></article>`;
    }).join('')}</section>`).join('') + (q.gift ? '<div class="bag-gift"><img src="' + nativeURL(window.GOBBI_ASSETS.thermos) + '" alt="GOBBi thermos"><div><strong>GOBBi On-the-Go Thermos · FREE</strong><p>$25 value. One gift with your first subscription delivery only.</p></div></div>' : '') + `</div><div class="bag-checkout"><div class="bag-totals"><span>Today’s subtotal</span><strong>${money(q.total)}</strong></div><p class="bag-small">Shipping and tax confirmed at checkout. Subscriptions renew at the product subtotal and schedule shown above, plus any applicable shipping and tax. Your thermos is a first-delivery gift only.</p><button class="button primary wide" id="checkout-preview" ${!q.canPurchase ? 'disabled' : ''}>Review checkout →</button><div class="checkout-notice" id="checkout-notice" hidden>This is a design preview. No order, subscription or payment has been created. Shopify checkout will confirm customer eligibility for the first-subscription gift, shipping, taxes, and recurring terms before payment.</div></div>`, $('#bag-content'));
    $$('[data-remove-cart]').forEach(button => button.addEventListener('click', () => {
      state.cart.splice(Number(button.dataset.removeCart), 1);
      persist();
      renderBag();
      update();
    }, GOBBI_LIFECYCLE.options()));
    $('#checkout-preview').addEventListener('click', () => {
      $('#checkout-notice').hidden = false;
    }, GOBBI_LIFECYCLE.options());
  }
  function updateMerch() {
    $$('[data-merch-cadence]').forEach(select => select.value = state.months);
    setText('[data-merch-plan]', state.mode === 'subscription' ? '20% off every delivery · {value_1} · All flavors in your subscription arrive together.' : state.welcome ? 'One-time purchase · Your 20% welcome offer applies.' : 'One-time purchase · Delivered once.', [intervalText(state.months)]);
    $$('[data-merch-card]').forEach(card => {
      const p = byId(card.dataset.merchCard), q = quote({
        [p.id]: 1
      }, state.mode, state.months, state.welcome);
      card.querySelector('[data-merch-price]').innerHTML = GOBBI_EDITOR.html(`${money(q.total)} <small>/ box</small>`, card.querySelector('[data-merch-price]'));
      card.querySelector('[data-merch-unit]').textContent = copy('{value_1} / stick · {value_2} sticks', [money(q.total / p.sticks), p.sticks], card.querySelector('[data-merch-unit]'));
      card.querySelector('[data-quick-add]').textContent = GOBBI_EDITOR.text(!p.available ? 'Out of stock · Notify me' : state.mode === 'subscription' ? 'Add subscription box' : 'Add to bag', card.querySelector('[data-quick-add]'));
    });
  }
  $$('[data-merch-cadence]').forEach(select => select.addEventListener('change', () => {
    state.months = Number(select.value);
    update();
  }, GOBBI_LIFECYCLE.options()));
  $$('[data-shop-filter]').forEach(button => button.addEventListener('click', () => {
    $$('[data-shop-filter]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
    $$('.shop-all-grid [data-merch-card]').forEach(card => card.hidden = button.dataset.shopFilter !== 'all' && button.dataset.shopFilter !== card.dataset.family);
  }, GOBBI_LIFECYCLE.options()));
  $$('[data-quick-add]').forEach(button => button.addEventListener('click', () => {
    const p = byId(button.dataset.quickAdd);
    if (!p.available) {
      openNotify(p.id);
      return;
    }
    addQuoteToBag(quote({
      [p.id]: 1
    }, state.mode, state.months, state.welcome));
  }, GOBBI_LIFECYCLE.options()));
  function addToBag() {
    const q = currentQuote();
    if (nativeCart && q.stockAvailable && !q.plansAvailable) {
      toast('Subscriptions are not ready yet. Please choose a one-time purchase.');
      return;
    }
    if (isProduct && !q.canPurchase) {
      const unavailable = state.mix.find(id => !byId(id).available);
      if (unavailable) {
        openNotify(unavailable);
        return;
      }
    }
    if (!q.canPurchase) {
      toast('Choose in-stock boxes before adding your delivery.');
      return;
    }
    addQuoteToBag(q);
  }
  function addQuoteToBag(q) {
    if (nativeCart) {
      addNativeQuote(q);
      return;
    }
    const next = state.cart.map(item => ({
      ...item
    }));
    for (const line of q.lines) {
      const found = next.find(item => item.id === line.product.id && item.mode === state.mode && item.months === state.months);
      if (found) found.quantity += line.quantity; else next.push({
        id: line.product.id,
        quantity: line.quantity,
        mode: state.mode,
        months: state.months
      });
    }
    if (!cartQuote(next, state.welcome).canPurchase) {
      toast('That quantity exceeds the available stock. Adjust your bag to continue.');
      return;
    }
    state.cart = next;
    persist();
    renderBag();
    openBagDrawer();
  }
  $('#builder-add')?.addEventListener('click', addToBag, GOBBI_LIFECYCLE.options());
  $('#product-add')?.addEventListener('click', addToBag, GOBBI_LIFECYCLE.options());
  $('#open-bag').addEventListener('click', () => {
    renderBag();
    openBagDrawer();
    if (nativeCart) nativeCart.read().catch(error => {
      renderBag();
      toast(error.message, true);
    });
  }, GOBBI_LIFECYCLE.options());
  function selectTab(button) {
    const name = button.dataset.detailTab;
    $$('[data-detail-tab]').forEach(b => b.setAttribute('aria-selected', String(b === button)));
    $$('[role="tabpanel"]').forEach(panel => panel.hidden = panel.id !== 'panel-' + name);
  }
  $$('[data-detail-tab]').forEach((button, index, buttons) => {
    button.addEventListener('click', () => selectTab(button), GOBBI_LIFECYCLE.options());
    button.addEventListener('keydown', event => {
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      const next = event.key === 'Home' ? 0 : event.key === 'End' ? buttons.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + buttons.length) % buttons.length;
      buttons[next].focus();
      selectTab(buttons[next]);
    }, GOBBI_LIFECYCLE.options());
  });
  if (isBuilder) filterFamily('energy');
  renderSlots();
  update();
  if (nativeCart) {
    bindNativeCartPage();
    nativeCart.read().catch(error => toast(error.message, true));
  }
  window.addEventListener('pageshow', event => {
    if (nativeCart && event.persisted) {
      nativeCart.releaseCheckout();
      nativeCart.read().catch(error => toast(error.message, true));
    }
  }, GOBBI_LIFECYCLE.options());
  const leftPicker = $('.builder-shop'), delivery = $('.builder-summary');
  function fitDelivery() {
    if (!leftPicker || !delivery) return;
    const desktop = matchMedia('(min-width:1051px)').matches;
    if (desktop) delivery.style.setProperty('--delivery-height', `${leftPicker.offsetHeight}px`); else delivery.style.removeProperty('--delivery-height');
  }
  if (leftPicker) {
    GOBBI_LIFECYCLE.resource("ResizeObserver", fitDelivery).observe(leftPicker);
    window.addEventListener('resize', fitDelivery, GOBBI_LIFECYCLE.options());
    fitDelivery();
  }
  const slider = $('#flavor-slider');
  if (slider) {
    const move = direction => slider.scrollBy({
      left: direction * slider.clientWidth * .85,
      behavior: matchMedia('(prefers-reduced-motion:reduce)').matches ? 'auto' : 'smooth'
    });
    $$('[data-slide]').forEach(button => button.addEventListener('click', () => move(Number(button.dataset.slide)), GOBBI_LIFECYCLE.options()));
    slider.addEventListener('keydown', event => {
      if (event.target !== slider || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
      event.preventDefault();
      move(event.key === 'ArrowRight' ? 1 : -1);
    }, GOBBI_LIFECYCLE.options());
    const updateArrows = () => {
      $('[data-slide="-1"]').disabled = slider.scrollLeft <= 1;
      $('[data-slide="1"]').disabled = slider.scrollLeft + slider.clientWidth >= slider.scrollWidth - 2;
    };
    slider.addEventListener('scroll', updateArrows, GOBBI_LIFECYCLE.options({
      passive: true
    }));
    GOBBI_LIFECYCLE.resource("ResizeObserver", updateArrows).observe(slider);
    updateArrows();
  }
})();

};
window.GOBBI_EDITOR.start();


